import { useContext, useRef } from "react";
import { UserContext } from "../context/UserContext";
import { Link } from "react-router-dom";
import About from "./About";
import LogOut from "../api/LogOut";
import { useClickOutside } from "../Hooks/UseClickOutside";
import { useCloseField, useMiniprofile, useToggleField } from "../Store/MenuSlice";
import { useAuth } from "../context/AuthContext";

export default function MiniProfile({ position }) {
  const { userInfo } = useContext(UserContext);
  const { isAuth } = useAuth();
  const miniProfile = useMiniprofile();
  const toggleField = useToggleField();
  const closeField = useCloseField();
  const mainRef = useRef(null);
  const buttonRef = useRef(null);
  useClickOutside(mainRef, () => closeField("miniProfile"), buttonRef);

  const ProfileList = () => {
    return (
      <div
        ref={mainRef}
        className={`profile-menu-container ${!miniProfile && "pro-hide-container"}`}
        style={{ visibility: !miniProfile ? "hidden" : "" }}>
        <ul
          className={`profile-menu d-flex flex-column align-items-center pl-10 pr-10 pb-10 index-6 ${
            !miniProfile ? "hide-mini-pro" : ""
          }`}>
          <li className="mt-10 mb-10 txt-center pb-15">
            <div className="d-flex flex-around pb-15 pt-10">
              <span>{userInfo.name}</span>
              <div>
                <span>{userInfo.points}</span>
                <span>xp</span>
              </div>
            </div>
            <Link className="" style={{ pointerEvents: "none", opacity: "0.6" }} to={"/profile"}>
              Go To Your Profile
            </Link>
          </li>

          <li className="menu d-flex flex-column align-start">
            <Link to={"/settings"}>Acount Settings</Link>
            <Link to={"/about#contact"}>help & support</Link>
            <LogOut />
            <button onClick={() => closeField("miniProfile")}>cancel</button>
            <button onClick={() => toggleField("about")}>more</button>
          </li>
        </ul>
        <About child={true} />
      </div>
    );
  };
  const IsLogin = () => {
    if (isAuth) {
      return (
        <>
          <button
            ref={buttonRef}
            onClick={() => toggleField("miniProfile")}
            className={`mini-Profile ${miniProfile ? "prime-c" : "mixed-c"}`}>
            {position !== "sidebar" ? (
              userInfo.name
            ) : (
              <i className="fa-solid fa-user text-size-400" style={{ color: "inherit" }}></i>
            )}
          </button>

          {ProfileList()}
        </>
      );
    } else {
      return (
        <nav className="d-flex flex-around log-links p-5">
          <Link style={{ whiteSpace: "nowrap" }} to={"/login"}>
            Log In
          </Link>
          <Link to={"/register"}>Sign Up</Link>
        </nav>
      );
    }
  };
  return <>{IsLogin()}</>;
}
